var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfilSeleccionIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.685,
    height: 80.684,
    viewBox: "0 0 113.685 80.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_599",
    "data-name": "Grupo 599",
    transform: "translate(-1065.999 -540)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_503",
    "data-name": "Grupo 503",
    transform: "translate(181.73 47.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person-add",
    transform: "translate(917.728 492.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_214",
    "data-name": "Trazado 214",
    d: "M957.841,532.643a20.056,20.056,0,1,0-20.056-20.056A20.116,20.116,0,0,0,957.841,532.643Zm0,10.028c-13.538,0-40.113,6.518-40.113,20.056v10.028h80.225V562.727C997.953,549.189,971.379,542.671,957.841,542.671Z",
    transform: "translate(-917.728 -492.53)",
    fill: "#3a5fa1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-document",
    "data-name": "Icon open-document",
    d: "M0,0V40.572H35.5V20.286H15.215V0ZM20.286,0V15.215H35.5ZM5.072,10.143h5.072v5.072H5.072Zm0,10.143h5.072v5.072H5.072Zm0,10.143H25.358V35.5H5.072Z",
    transform: "translate(1065.999 540)",
    fill: "#3a5fa1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilSeleccionIcon03);
export default __webpack_public_path__ + "static/media/perfil-seleccion-icon-03.a3714d20f5e0698512614fc7422f9dec.svg";
export { ForwardRef as ReactComponent };